import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    empty: 'No giveaways yet',
    winnersOne: '{{count}} winner',
    winnersFew: '{{count}} winners',
    winnersMany: '{{count}} winners',
  },
  ru: {
    empty: 'Раздач ещё не было',
    winnersOne: '{{count}} победитель',
    winnersFew: '{{count}} победителя',
    winnersMany: '{{count}} победителей',
  },
  uz: {
    empty: 'Hali ulashish boʻlmagan',
    winnersOne: '{{count}} gʻolib',
    winnersFew: '{{count}} gʻolib',
    winnersMany: '{{count}} gʻolib',
  },
  fa: {
    empty: 'هنوز پخشی نبوده',
    winnersOne: '{{count}} برنده',
    winnersFew: '{{count}} برنده',
    winnersMany: '{{count}} برنده',
  },
  pt: {
    empty: 'Ainda não houve sorteios',
    winnersOne: '{{count}} vencedor',
    winnersFew: '{{count}} vencedores',
    winnersMany: '{{count}} vencedores',
  },
  tr: {
    empty: 'Henüz çekiliş olmadı',
    winnersOne: '{{count}} kazanan',
    winnersFew: '{{count}} kazanan',
    winnersMany: '{{count}} kazanan',
  },
});
